import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetNotificationsReqData } from "./GetNotificationsReqData";
import { GetNotificationsResData } from "./GetNotificationsResData";

const ENDPOINT = "/notifications/notifications_paginated";

export class GetNotificationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetNotificationsReqData = null;

    constructor(payload: GetNotificationsReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<GetNotificationsResData> {
        var res = await this.executeCommand(this.payload, null, null);
        return new GetNotificationsResData(res);
    }
}
